import React from "react";
import { Button } from "components";
import { useChangesHistoryContext } from "./context";

const RotateLeftIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.6522 13.7518C13.2749 13.264 13.7955 12.6584 14.1843 11.9695C14.573 11.2806 14.8222 10.5219 14.9177 9.73663C15.0132 8.95139 14.9531 8.15504 14.7408 7.39304C14.5285 6.63103 14.1683 5.9183 13.6805 5.29553C12.6956 4.03779 11.2513 3.22285 9.66542 3.02999C8.07957 2.83713 6.48206 3.28215 5.22432 4.26714M8.11468 5.93589L4.86709 4.06089L6.74209 0.813293" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.69312 14.9609L9.68662 14.9572" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.40601 6.67969L3.39951 6.67594" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.98572 9.76562L2.97922 9.76188" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.16101 12.6328L4.15452 12.6291" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.61023 14.5391L6.60373 14.5353" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
;
const RotateRightIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.279 13.7518C4.65623 13.264 4.13562 12.6584 3.7469 11.9695C3.35818 11.2806 3.10896 10.5219 3.01346 9.73663C2.91797 8.95139 2.97807 8.15504 3.19034 7.39304C3.40261 6.63103 3.76289 5.9183 4.25061 5.29553C5.2356 4.03779 6.67988 3.22285 8.26573 3.02999C9.85158 2.83713 11.4491 3.28215 12.7068 4.26714M9.81647 5.93589L13.0641 4.06089L11.1891 0.813293" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.23804 14.9609L8.24453 14.9572" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.5251 6.67969L14.5316 6.67594" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.9454 9.76562L14.9519 9.76188" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.7701 12.6328L13.7766 12.6291" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.3209 14.5391L11.3274 14.5353" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
;



const HistoryButtons = () => {

  const { goHistoryForward, goHistoryBack, currentStateIndex, history } = useChangesHistoryContext();

  if(currentStateIndex === 0 && history.length === 1) {
      return null;
  }

  return (
    <div className="d-flex" style={{ borderRight: "1px solid var(--black2)", paddingRight: ".75rem" }}>
      {currentStateIndex === 0 ? null : <Button square variant="secondary" size="large" onClick={goHistoryBack} disabled={currentStateIndex === 0}>
        <RotateLeftIcon />
      </Button>}

        {currentStateIndex + 1 === history.length ? null : <Button square variant="secondary" size="large" style={{ marginLeft: ".75rem" }} onClick={goHistoryForward} disabled={currentStateIndex + 1 === history.length}>
        <RotateRightIcon />
      </Button>}
    </div>
  );
};

export default HistoryButtons;
